// extracted by mini-css-extract-plugin
export default {"list":"intuitive-healing_list__9f4c5"};